module.exports = __webpack_public_path__ + "img/fi-cloudpro.46d98aaa.png";